import MetricTabs from './MetricTabs';

export default MetricTabs;
